var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000144958 21.003C0.000144958 9.71275 9.15273 0.560169 20.443 0.560169C31.7333 0.560169 40.8859 9.71275 40.8859 21.003C40.8859 32.2933 31.7333 41.4459 20.443 41.4459C9.15273 41.4459 0.000144958 32.2933 0.000144958 21.003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 41.5002C31.8219 41.5002 41 32.3222 41 21.0004C41 9.67857 31.8219 0.500118 20.5001 0.500118C9.17833 0.500118 -0.000125885 9.67857 -0.000125885 21.0004C0.0126381 32.3169 9.18321 41.4875 20.5001 41.5002ZM20.5001 2.55037C30.6898 2.55037 38.9501 10.8107 38.9501 21.0004C38.9501 31.1901 30.6898 39.4504 20.5001 39.4504C10.3104 39.4504 2.05013 31.1901 2.05013 21.0004C2.06176 10.8156 10.3153 2.562 20.5001 2.55037Z",
    fill: "#C1C5FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9002 28.9469C23.3266 29.3196 23.9741 29.2761 24.3469 28.85C24.7192 28.4236 24.6757 27.7761 24.2497 27.4034L16.9315 21.0004L24.25 14.597C24.6765 14.2243 24.7196 13.5768 24.3473 13.1507C23.9745 12.7243 23.327 12.6808 22.9006 13.0535L14.7007 20.2286C14.4781 20.4231 14.3505 20.7046 14.3505 21.0004C14.3505 21.2962 14.4781 21.5773 14.7007 21.7721L22.9002 28.9469Z",
    fill: "#504F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.01238aa37d891e16f9f7c7d9a7739b52.svg";
export { ForwardRef as ReactComponent };